import type { IconNode } from '../types';

/**
 * @name tie-bow
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiB4PSIxMCIgeT0iMTAiIC8+CiAgPHBhdGggZD0iTTggMTJoMiIgLz4KICA8cGF0aCBkPSJNMTAgMTBDOC44IDguNSA2LjYgNyA0IDdjLTEuMSAwLTIgMi4yLTIgNXMuOSA1IDIgNWMyLjYgMCA0LjgtMS41IDYtMyIgLz4KICA8cGF0aCBkPSJNMTQgMTJoMiIgLz4KICA8cGF0aCBkPSJNMTQgMTRjMS4yIDEuNSAzLjQgMyA2IDMgMS4xIDAgMi0yLjIgMi01cy0uOS01LTItNWMtMi42IDAtNC44IDEuNS02IDMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/tie-bow
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const tieBow: IconNode = [
  ['rect', { width: '4', height: '4', x: '10', y: '10', key: 'vipc7x' }],
  ['path', { d: 'M8 12h2', key: 'f27al2' }],
  [
    'path',
    { d: 'M10 10C8.8 8.5 6.6 7 4 7c-1.1 0-2 2.2-2 5s.9 5 2 5c2.6 0 4.8-1.5 6-3', key: '14in43' },
  ],
  ['path', { d: 'M14 12h2', key: '5yx4ln' }],
  [
    'path',
    { d: 'M14 14c1.2 1.5 3.4 3 6 3 1.1 0 2-2.2 2-5s-.9-5-2-5c-2.6 0-4.8 1.5-6 3', key: '4pwg92' },
  ],
];

export default tieBow;
